import { Grid } from "@mui/material";
import { Actions } from '../Modal'
import { Form, Input, Submit, MenuSelect } from '../Form'
import { useDispatch, useSelector } from "react-redux";
import { createTeacher, editTeacher } from "../../features/teachers/teachersSlice";
import { useForm } from "react-hook-form";

const properties = { id: '', codigo: '', nombre: '', genero: '', departamento: '', idArea: '' };

const Forms = () => {
    const { id, openModalEdit } = useSelector(state => state.modal);
    const { teachers } = useSelector(state => state.teachers);
    const { departments } = useSelector(state => state.departments);
    const genders = [{ id: 'H', nombre: 'Hombre' }, { id: 'M', nombre: 'Mujer' }]
    const dispatch = useDispatch();
    const methods = useForm({ shouldUnregister: true })
    const onSubmit = values => dispatch(openModalEdit ? editTeacher({ id, values, setError: methods.setError }) : createTeacher({ values, setError: methods.setError }) );
    const data = openModalEdit ? teachers.find(el => el.id === id) : properties;
    return(
        <Actions title={openModalEdit ? 'Editar' : 'Nuevo'}>
            <Form methods={methods} onSubmit={onSubmit}>
                <Grid container spacing={2}>
                    <Input name={'codigo'} label="Código" min={7} max={7} regEx={/[0-9A-Z]/g} val={ data.codigo } size={3} /> 
                    <Input name={'nombre'} label="Nombre" val={ data.nombre } size={9} />
                    <MenuSelect name={'genero'} label="Sexo" options={genders} val={ genders.find(el => el.id === data.genero)?.id } />
                    <MenuSelect name={'departamento'} label="Departamento" val={data.idArea } options={departments} />
                    <Submit title={openModalEdit ? 'Guardar cambios' : 'Registrar'} />
                </Grid>
            </Form>
        </Actions>
    )
}

export default Forms;